import { createStore, applyMiddleware } from 'redux'
import { createLogger, logger } from 'redux-logger'
import { persistReducer, persistStore } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import thunk from 'redux-thunk'

import reducers from './ducks'

const allowLogger = process.env.REACT_APP_ALLOW_LOGGER === 'true'

const persistConfig = {
  key: 'root',
  storage
}

const middlewares = []
middlewares.push(thunk)

if (allowLogger) {
  const logger = createLogger({ collapsed: true })
  middlewares.push(logger)
}

const createStoreWithMiddleware = applyMiddleware(...middlewares)(createStore)

const rootReducer = (state: any, action: any) => reducers(state, action)

const persistedReducer = persistReducer(persistConfig, rootReducer)

export default () => {
  const store = createStoreWithMiddleware(persistedReducer)
  const persistor = persistStore(store)
  return { persistor, store }
}

